export default __webpack_public_path__ + "static/impact-global-map-e06d57c6fe8642a51606cadc95cca542.jpg";